@import (reference) "../../references.less";

.root {
  position: absolute;
  top: 0;
  left: 0;
}

.rect {
  position: absolute;
  .size(100%);
  background: rgba(255, 255, 255, 0);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid @color-red;
}

.cross {
  @size: 23;
  .R(width, @size);
  .R(height, @size);
  display: block;
  position: absolute;
  .R(top, -@size/2);
  .R(right, -@size/2);
  z-index: 0;
  cursor: pointer;

  .crossBg {
    border-radius: 100%;
    background-color: @color-red;
    transform: scale(1);
    transition: transform 100ms ease-out;
    .size(100%);
    pointer-events: none;
  }

  svg {
    .absoluteCenter();
    @size: 10;
    .R(width, @size);
    .R(height, @size);
  }

  &:hover {
    .crossBg {
      transform: scale(1.4);
    }
  }
}
